import { SfaSalesGroupContainerModel } from '../../../../../../models/aggregates/sfa/salesGroup/SfaSalesGroupContainer.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class SfaSalesGroupService extends BaseApiTemplateService<SfaSalesGroupContainerModel> {
    static readonly SALES_GROUP_SUB_PATH = 'sales-group-hdrs/';

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + SfaSalesGroupService.SALES_GROUP_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + SfaSalesGroupService.SALES_GROUP_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + SfaSalesGroupService.SALES_GROUP_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}